import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { listUserAccounts, setUserRoles, deleteUserAccount, resetUserPassword, listMySchools, listPasswordBackups, createPasswordBackup, getPasswordBackup, restorePasswordBackup, deletePasswordBackup, backupOnePassword, listOnePasswordPoints, restoreOnePassword } from "./happyschoolApi";
import { getActiveSchoolId } from "./activeSchool";

// Danh sách tài khoản đăng nhập (SĐT): nạp sẵn + người dùng tự đăng ký.
const roleLabel = (r) => ({ owner: "Chủ trường", admin: "Quản trị", teacher: "Giáo viên/Nhân sự", student: "Học sinh", schedule_viewer: "Ban giám hiệu (Xếp TKB)", cntt: "CNTT (Quản lý dạy học)" }[r] || "—");
const ROLE_OPTIONS = [["", "— (gỡ khỏi trường)"], ["student", "Học sinh"], ["teacher", "Giáo viên/Nhân sự"], ["schedule_viewer", "Ban giám hiệu (Xếp TKB)"], ["cntt", "CNTT (Quản lý dạy học)"], ["admin", "Quản trị"], ["owner", "Chủ trường"]];


// Sao lưu / khôi phục mật khẩu (chỉ chủ trường). Chỉ lưu MÃ BĂM mật khẩu (không có mật khẩu gốc) của các tài khoản thành viên trường.
const PasswordBackupPanel = ({ schoolId, onRestored }) => {
  const [list, setList] = useState(null);
  const [open, setOpen] = useState("");
  const [detail, setDetail] = useState(null);
  const [pick, setPick] = useState({});
  const [onlyChanged, setOnlyChanged] = useState(true);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  const fmt = (t) => (t ? new Date(t).toLocaleString("vi-VN") : "");
  const load = () => listPasswordBackups(schoolId).then(setList).catch((e) => setErr(e.message));
  useEffect(() => { load(); }, [schoolId]); // eslint-disable-line
  const run = async (fn) => { setBusy(true); setErr(""); setMsg(""); try { await fn(); } catch (e) { setErr(e.message); } finally { setBusy(false); } };
  const backupNow = () => {
    const note = window.prompt("Ghi chú cho bản sao lưu (có thể để trống):", "");
    if (note === null) return;
    run(async () => { const r = await createPasswordBackup(schoolId, note); setMsg(`Đã sao lưu mật khẩu của ${r.count} tài khoản.`); await load(); });
  };
  const view = (id) => run(async () => { const d = await getPasswordBackup(schoolId, id); setOpen(id); setDetail(d); setPick({}); });
  const rows = detail ? detail.rows.filter((r) => !onlyChanged || r.changed || r.missing) : [];
  const chosen = Object.keys(pick).filter((k) => pick[k]);
  const restore = (payload, label) => {
    if (!window.confirm(`Khôi phục mật khẩu ${label} về đúng thời điểm ${fmt(detail.createdAt)}?\nHệ thống tự sao lưu hiện trạng trước khi ghi đè.`)) return;
    run(async () => {
      const r = await restorePasswordBackup(schoolId, open, payload);
      setMsg(`Đã khôi phục ${r.restored} tài khoản${(r.skipped || []).length ? `, bỏ qua ${r.skipped.length} (${r.skipped.slice(0, 5).map((x) => `${x.name || x.phone}: ${x.reason}`).join("; ")}${r.skipped.length > 5 ? "..." : ""})` : ""}.`);
      await load(); const d = await getPasswordBackup(schoolId, open); setDetail(d); setPick({}); if (onRestored) onRestored();
    });
  };
  const del = (id) => { if (!window.confirm("Xoá bản sao lưu này? Không hoàn tác được.")) return; run(async () => { await deletePasswordBackup(schoolId, id); if (open === id) { setOpen(""); setDetail(null); } await load(); }); };
  return (
    <div style={{ border: "1px solid #bae6fd", background: "#f0f9ff", borderRadius: 8, padding: 12, marginBottom: 14 }}>
      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
        <b>🔐 Sao lưu / khôi phục mật khẩu</b>
        <button type="button" disabled={busy} onClick={backupNow} style={{ ...resetBtn, fontWeight: 700 }}>💾 Sao lưu mật khẩu ngay</button>
        <span style={{ fontSize: 12, color: "#6b7280" }}>Chỉ lưu mã băm mật khẩu của các tài khoản thành viên trường — không có mật khẩu gốc.</span>
      </div>
      {err && <p style={{ color: "#dc2626", margin: "6px 0 0" }}>{err}</p>}
      {msg && <p style={{ color: "#059669", margin: "6px 0 0" }}>{msg}</p>}
      {list === null ? <p style={{ margin: "6px 0 0" }}>Đang tải...</p> : list.length === 0 ? <p style={{ color: "#6b7280", margin: "6px 0 0", fontSize: 13 }}>Chưa có bản sao lưu nào.</p> : (
        <table style={{ marginTop: 8, borderCollapse: "collapse", fontSize: 13, background: "#fff" }}>
          <thead><tr><th style={th}>Thời điểm</th><th style={th}>Số tài khoản</th><th style={{ ...th, textAlign: "left" }}>Ghi chú</th><th style={th}>Thao tác</th></tr></thead>
          <tbody>
            {list.map((b) => (
              <tr key={b.id} style={{ background: open === b.id ? "#ecfeff" : undefined }}>
                <td style={td}>{fmt(b.createdAt)}</td><td style={td}>{b.count}</td>
                <td style={{ ...td, textAlign: "left" }}>{b.auto ? "🤖 " : ""}{b.note || "—"}</td>
                <td style={{ ...td, whiteSpace: "nowrap" }}>
                  <button type="button" disabled={busy} onClick={() => view(b.id)} style={resetBtn}>Xem / Khôi phục</button>{" "}
                  <button type="button" disabled={busy} onClick={() => del(b.id)} style={delBtn} title="Xoá bản sao lưu">🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
      {detail && (
        <div style={{ marginTop: 10, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 8, padding: 10 }}>
          <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 6 }}>
            <b>Bản {fmt(detail.createdAt)}</b>
            <label style={{ fontSize: 13 }}><input type="checkbox" checked={onlyChanged} onChange={(e) => setOnlyChanged(e.target.checked)} /> Chỉ hiện tài khoản đã đổi mật khẩu so với bản này</label>
            <span style={{ flex: 1 }} />
            <button type="button" disabled={busy || !chosen.length} onClick={() => restore({ phones: chosen }, `${chosen.length} tài khoản đã chọn`)} style={{ ...resetBtn, fontWeight: 700 }}>↩ Khôi phục {chosen.length} đã chọn</button>
            <button type="button" disabled={busy} onClick={() => restore({ all: true }, "TẤT CẢ tài khoản")} style={{ ...delBtn, fontWeight: 700 }}>↩ Khôi phục tất cả</button>
            <button type="button" onClick={() => { setOpen(""); setDetail(null); }} style={resetBtn}>Đóng</button>
          </div>
          {rows.length === 0 ? <p style={{ color: "#6b7280", fontSize: 13, margin: 0 }}>Không có tài khoản nào khác bản sao lưu này.</p> : (
            <div style={{ maxHeight: 280, overflow: "auto" }}>
              <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
                <thead><tr><th style={th}><input type="checkbox" checked={rows.filter((r) => !r.missing).every((r) => pick[r.phone]) && rows.some((r) => !r.missing)} onChange={(e) => setPick(Object.fromEntries(rows.filter((r) => !r.missing).map((r) => [r.phone, e.target.checked])))} /></th><th style={{ ...th, textAlign: "left" }}>Họ và tên</th><th style={th}>SĐT</th><th style={th}>Trạng thái</th></tr></thead>
                <tbody>
                  {rows.map((r) => (
                    <tr key={r.phone}>
                      <td style={td}><input type="checkbox" disabled={r.missing} checked={!!pick[r.phone]} onChange={(e) => setPick((p) => ({ ...p, [r.phone]: e.target.checked }))} /></td>
                      <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{r.name || "(chưa đặt tên)"}</td><td style={td}>{r.phone}</td>
                      <td style={td}>{r.missing ? <span style={{ color: "#9ca3af" }}>Tài khoản không còn</span> : r.changed ? <span style={{ color: "#b45309" }}>Đã đổi mật khẩu</span> : <span style={{ color: "#059669" }}>Giống bản sao lưu</span>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const HappySchoolUserAccounts = () => {
  const schoolId = getActiveSchoolId();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [q, setQ] = useState("");
  const [filter, setFilter] = useState("all"); // all | self | seeded
  const [isOwner, setIsOwner] = useState(false);
  const [busy, setBusy] = useState("");
  const [resetUid, setResetUid] = useState("");
  const [resetValue, setResetValue] = useState("");
  const [resetMsg, setResetMsg] = useState("");
  useEffect(() => { if (!resetMsg) return undefined; const t = setTimeout(() => setResetMsg(""), 8000); return () => clearTimeout(t); }, [resetMsg]);
  const [pointsUid, setPointsUid] = useState("");
  const [points, setPoints] = useState(null);

  const reload = () => {
    if (!schoolId) return;
    setLoading(true);
    listUserAccounts(schoolId)
      .then((list) => setRows((list || []).sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0) || a.name.localeCompare(b.name, "vi"))))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };
  useEffect(reload, [schoolId]);
  useEffect(() => {
    if (!schoolId) return;
    listMySchools().then((l) => { const s = (l || []).find((x) => x.id === schoolId); setIsOwner(!!s && s.role === "owner"); }).catch(() => {});
  }, [schoolId]);

  // Sửa nhiều vai trò: uid đang mở bảng tích + các vai trò đang tích
  const [editRolesUid, setEditRolesUid] = useState("");
  const [editRoles, setEditRoles] = useState([]);
  const rolesOf = (r) => (Array.isArray(r.roles) && r.roles.length ? r.roles : r.role ? [r.role] : []);
  const saveRoles = async (uid) => {
    if (!editRoles.length && !window.confirm("Không tích vai trò nào = GỠ tài khoản này khỏi trường. Tiếp tục?")) return;
    setBusy(uid); setError("");
    try { await setUserRoles(schoolId, uid, editRoles); setEditRolesUid(""); reload(); }
    catch (e) { setError(e.message); } finally { setBusy(""); }
  };
  const removeAcc = async (uid, name) => {
    if (!window.confirm(`Xoá hẳn tài khoản "${name}"? Hành động này không hoàn tác được.`)) return;
    setBusy(uid); setError("");
    try { await deleteUserAccount(schoolId, uid); reload(); }
    catch (e) { setError(e.message); } finally { setBusy(""); }
  };

  const openReset = (uid) => { setResetUid(uid); setResetValue(""); setResetMsg(""); setError(""); };
  const doReset = async (uid) => {
    if (!resetValue.trim()) { setError("Nhập mật khẩu mới."); return; }
    setBusy(uid); setError(""); setResetMsg("");
    try {
      await resetUserPassword(schoolId, uid, resetValue.trim());
      setResetMsg(`Đã reset mật khẩu về "${resetValue.trim()}". Người dùng sẽ bị buộc đổi sang mật khẩu mạnh ở lần đăng nhập kế tiếp.`);
      setResetUid(""); setResetValue("");
    } catch (e) { setError(e.message); } finally { setBusy(""); }
  };

  // Sao lưu / khôi phục mật khẩu của TỪNG tài khoản (cạnh nút reset)
  const backupOne = async (uid, name) => {
    const note = window.prompt(`Ghi chú cho bản sao lưu mật khẩu của "${name || "tài khoản này"}" (có thể để trống):`, "");
    if (note === null) return;
    setBusy(uid); setError(""); setResetMsg("");
    try { await backupOnePassword(schoolId, uid, note); setResetMsg(`Đã sao lưu mật khẩu hiện tại của "${name || "tài khoản"}".`); if (pointsUid === uid) setPointsUid(""); }
    catch (e) { setError(e.message); } finally { setBusy(""); }
  };
  const openPoints = async (uid) => {
    if (pointsUid === uid) { setPointsUid(""); return; }
    setBusy(uid); setError(""); setResetMsg(""); setPoints(null);
    try { const d = await listOnePasswordPoints(schoolId, uid); setPoints(d.points || []); setPointsUid(uid); }
    catch (e) { setError(e.message); } finally { setBusy(""); }
  };
  const restoreOne = async (uid, name, pt) => {
    if (!window.confirm(`Khôi phục mật khẩu của "${name || "tài khoản"}" về bản ngày ${new Date(pt.createdAt).toLocaleString("vi-VN")}?\nHệ thống tự sao lưu mật khẩu hiện tại trước khi ghi đè.`)) return;
    setBusy(uid); setError(""); setResetMsg("");
    try {
      const r = await restoreOnePassword(schoolId, uid, pt.id);
      setResetMsg(r.restored ? `Đã khôi phục mật khẩu của "${name || "tài khoản"}".` : "Mật khẩu hiện tại đã giống bản sao lưu này, không cần khôi phục.");
      setPointsUid("");
    } catch (e) { setError(e.message); } finally { setBusy(""); }
  };

  const shown = useMemo(() => {
    const kw = q.trim().toLowerCase();
    return rows.filter((r) => {
      if (filter === "self" && !r.selfRegistered) return false;
      if (filter === "seeded" && r.selfRegistered) return false;
      if (!kw) return true;
      return (r.name || "").toLowerCase().includes(kw) || (r.phone || "").includes(kw);
    });
  }, [rows, q, filter]);

  const nSelf = rows.filter((r) => r.selfRegistered).length;

  if (!schoolId) return <div style={{ padding: 24 }}>Chưa chọn trường. Vào <Link to="/happyschool/schools">Trường của tôi</Link>.</div>;

  return (
    <div style={{ padding: 24, maxWidth: 1000, margin: "0 auto" }}>
      <h2 style={{ margin: "0 0 4px" }}>👤 Tài khoản người dùng</h2>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Tổng <b>{rows.length}</b> tài khoản đăng nhập bằng SĐT — trong đó <b>{nSelf}</b> tự đăng ký, {rows.length - nSelf} nạp sẵn.
      </p>

      {isOwner && <PasswordBackupPanel schoolId={schoolId} onRestored={reload} />}

      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", marginBottom: 12 }}>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Tìm theo tên / SĐT" style={{ padding: "7px 10px", border: "1px solid #d1d5db", borderRadius: 6, minWidth: 220 }} />
        {[["all", "Tất cả"], ["self", "Tự đăng ký"], ["seeded", "Nạp sẵn"]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setFilter(k)} style={filter === k ? chipA : chipS}>{l}</button>
        ))}
      </div>

      {/* Thông báo NỔI cố định góc màn hình: người dùng đang cuộn ở hàng tài khoản thì vẫn thấy kết quả sao lưu / khôi phục / reset. */}
      {(error || resetMsg) && (
        <div role="status" style={{ position: "fixed", top: 16, right: 16, zIndex: 1000, maxWidth: 380, padding: "10px 14px", borderRadius: 8, boxShadow: "0 4px 14px rgba(0,0,0,.18)", fontSize: 14, background: error ? "#fef2f2" : "#ecfdf5", border: `1px solid ${error ? "#fca5a5" : "#6ee7b7"}`, color: error ? "#b91c1c" : "#047857" }}>
          <button type="button" onClick={() => { setError(""); setResetMsg(""); }} style={{ float: "right", marginLeft: 8, border: "none", background: "transparent", cursor: "pointer", fontSize: 16, lineHeight: 1, color: "inherit" }} title="Đóng">×</button>
          {error || resetMsg}
        </div>
      )}
      {loading ? <p>Đang tải...</p> : (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead><tr>
              <th style={th}>STT</th><th style={{ ...th, textAlign: "left" }}>Họ và tên</th><th style={th}>SĐT</th>
              <th style={th}>Nguồn</th><th style={th}>Vai trò</th><th style={th}>Đăng nhập</th><th style={th}>Xác thực thông tin</th><th style={th}>Ngày tạo</th>
              {isOwner && <th style={th}>Thao tác</th>}
            </tr></thead>
            <tbody>
              {shown.length === 0 ? (
                <tr><td colSpan={isOwner ? 9 : 8} style={{ ...td, color: "#6b7280", padding: 16 }}>Không có tài khoản khớp.</td></tr>
              ) : shown.map((r, i) => (
                <tr key={r.phone}>
                  <td style={td}>{i + 1}</td>
                  <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{r.name || "(chưa đặt tên)"}</td>
                  <td style={td}>{r.phone}</td>
                  <td style={td}>{r.selfRegistered ? <span style={{ color: "#0f766e" }}>Tự đăng ký</span> : "Nạp sẵn"}</td>
                  <td style={td}>{rolesOf(r).length ? rolesOf(r).map(roleLabel).join(" + ") : "—"}</td>
                  <td style={td}>{r.role ? (r.verified ? "✓ Đã đăng nhập" : "Chưa đăng nhập") : "—"}</td>
                  <td style={td}>
                    {rolesOf(r).some((x) => ["teacher", "staff", "student", "schedule_viewer"].includes(x))
                      ? (r.profileVerified ? <span style={{ color: "#059669", fontWeight: 600 }}>✓ Đã xác thực</span> : <span style={{ color: "#b45309" }}>Chưa xác thực</span>)
                      : "—"}
                  </td>
                  <td style={td}>{r.createdAt ? new Date(r.createdAt).toLocaleDateString("vi-VN") : "—"}</td>
                  {isOwner && (
                    <td style={{ ...td, whiteSpace: "nowrap" }}>
                      {editRolesUid === r.uid ? (
                        <span style={{ display: "inline-flex", flexDirection: "column", gap: 2, padding: 6, border: "1px solid #99f6e4", background: "#f0fdfa", borderRadius: 6, textAlign: "left", verticalAlign: "top" }}>
                          {ROLE_OPTIONS.filter(([v]) => v).map(([v, l]) => (
                            <label key={v} style={{ fontSize: 12, whiteSpace: "nowrap" }}>
                              <input type="checkbox" checked={editRoles.includes(v)} onChange={() => setEditRoles((a) => (a.includes(v) ? a.filter((x) => x !== v) : [...a, v]))} /> {l}
                            </label>
                          ))}
                          <span style={{ display: "flex", gap: 4, marginTop: 4 }}>
                            <button disabled={busy === r.uid} onClick={() => saveRoles(r.uid)} style={resetBtn}>Lưu</button>
                            <button onClick={() => setEditRolesUid("")} style={resetBtn}>Huỷ</button>
                          </span>
                        </span>
                      ) : (
                        <button disabled={busy === r.uid} onClick={() => { setEditRolesUid(r.uid); setEditRoles(rolesOf(r)); }} style={resetBtn} title="Chọn 1 hoặc nhiều vai trò">👥 Vai trò</button>
                      )}{" "}
                      {resetUid === r.uid ? (
                        <span style={{ display: "inline-flex", gap: 4, alignItems: "center" }}>
                          <input
                            autoFocus
                            value={resetValue}
                            onChange={(e) => setResetValue(e.target.value)}
                            onKeyDown={(e) => e.key === "Enter" && doReset(r.uid)}
                            placeholder="Mật khẩu mới"
                            style={{ padding: 4, border: "1px solid #d1d5db", borderRadius: 6, fontSize: 12, width: 100 }}
                          />
                          <button disabled={busy === r.uid} onClick={() => doReset(r.uid)} style={resetBtn} title="Xác nhận reset">✓</button>
                          <button disabled={busy === r.uid} onClick={() => setResetUid("")} style={delBtn} title="Huỷ">✕</button>
                        </span>
                      ) : (
                        <button disabled={busy === r.uid} onClick={() => openReset(r.uid)} style={resetBtn} title="Reset mật khẩu">🔑</button>
                      )}{" "}
                      <button disabled={busy === r.uid} onClick={() => backupOne(r.uid, r.name)} style={resetBtn} title="Sao lưu mật khẩu hiện tại của tài khoản này">💾</button>{" "}
                      <button disabled={busy === r.uid} onClick={() => openPoints(r.uid)} style={pointsUid === r.uid ? { ...resetBtn, background: "#ecfeff" } : resetBtn} title="Khôi phục mật khẩu từ bản sao lưu">↩</button>
                      {pointsUid === r.uid && (
                        <div style={{ marginTop: 6, padding: 8, border: "1px solid #99f6e4", background: "#f0fdfa", borderRadius: 6, textAlign: "left", fontSize: 12, whiteSpace: "normal", minWidth: 260 }}>
                          <b>Khôi phục mật khẩu — {r.name || r.phone}</b>
                          {!points || points.length === 0 ? <div style={{ color: "#6b7280", marginTop: 4 }}>Chưa có bản sao lưu nào của tài khoản này.</div> : points.map((pt) => (
                            <div key={pt.id} style={{ display: "flex", gap: 6, alignItems: "center", marginTop: 4 }}>
                              <span style={{ flex: 1 }}>{new Date(pt.createdAt).toLocaleString("vi-VN")}{pt.auto ? " 🤖" : ""}{pt.kind === "full" ? " (cả trường)" : ""}{pt.note ? ` — ${pt.note}` : ""}{pt.same ? " · giống hiện tại" : ""}</span>
                              <button disabled={busy === r.uid || pt.same} onClick={() => restoreOne(r.uid, r.name, pt)} style={resetBtn}>Khôi phục</button>
                            </div>
                          ))}
                          <div style={{ marginTop: 6 }}><button onClick={() => setPointsUid("")} style={resetBtn}>Đóng</button></div>
                        </div>
                      )}{" "}
                      <button disabled={busy === r.uid} onClick={() => removeAcc(r.uid, r.name)} style={delBtn} title="Xoá hẳn tài khoản">🗑</button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const th = { border: "1px solid #e5e7eb", padding: "8px 10px", background: "#f9fafb", textAlign: "center", fontSize: 13, whiteSpace: "nowrap" };
const td = { border: "1px solid #e5e7eb", padding: "6px 10px", textAlign: "center" };
const chipS = { padding: "6px 12px", background: "#fff", color: "#374151", border: "1px solid #d1d5db", borderRadius: 999, cursor: "pointer", fontSize: 13 };
const chipA = { ...chipS, background: "#0ea5a3", color: "#fff", borderColor: "#0ea5a3", fontWeight: 700 };
const delBtn = { padding: "3px 8px", background: "#fff", color: "#dc2626", border: "1px solid #fecaca", borderRadius: 6, cursor: "pointer" };
const resetBtn = { padding: "3px 8px", background: "#fff", color: "#0f766e", border: "1px solid #a7f3d0", borderRadius: 6, cursor: "pointer" };

export default HappySchoolUserAccounts;
